// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"455":"97c52d3e11e8753b","4896":"cba8579f1c5b5048"}[chunkId] + ".css";
};